var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m5.41 16.37 6.027 4.498c3.218-1.196 7.572-5.492 8.811-8.812l-4.497-6.027c-.618 3.082-7.258 9.722-10.34 10.342Zm6.322-2.459 1.503 1.503c.412.412 1.068.524 1.581.01.514-.514.402-1.169-.01-1.581l-1.502-1.503.982-.982 1.502 1.503c.928.927.888 2.47-.088 3.447-.976.976-2.52 1.016-3.447.088l-1.503-1.502.982-.982Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m17.378 21.979-2.104-2.105a20.311 20.311 0 0 0 3.977-3.985l2.109 2.108a2.815 2.815 0 0 1-3.982 3.982Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.611 12.752c-2.378-2.378-2.396-6.216-.04-8.572 2.357-2.357 6.194-2.339 8.572.04.64.64 1.11 1.385 1.407 2.18.01 2.143-5.615 7.769-7.758 7.759a6.115 6.115 0 0 1-2.181-1.407Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalx);
export default __webpack_public_path__ + "static/media/talx.e375deecab247d553bca094a669bf1e9.svg";
export { ForwardRef as ReactComponent };